import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ClientCheckinEventType } from '@fitness-force/enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-check-in-event',
  templateUrl: './check-in-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class CheckInEventComponent implements OnInit {
  private translate = inject(TranslateService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  ngOnInit(): void {}

  setCheckInEvent(event: any) {
    return ClientCheckinEventType[
      event as keyof typeof ClientCheckinEventType
    ].toString();
  }
}
